/**
 * @fileoverview The CBAM certificate calendar and fee the Certificates page is
 * built on (docs/features/certificate-management/00-OVERVIEW.md).
 *
 * Two certificate years, kept apart (D3): 2026 certificates cover only the
 * 2026 surrender, 2027 certificates only the 2027 checks and surrender.
 */

/** The years the page offers (D4). 2028+ is not offered yet. */
export const CERTIFICATE_YEARS = Object.freeze([2026, 2027]);

/**
 * The platform fee per certificate (D8): the default a new purchase records
 * (each purchase stores its own `feePerCertificate`). Costs money does not read
 * it: the backend prices the fee into every cost (backend `platformFee.ts`,
 * docs/features/costs-certificate-fee phase 2), and this must match its value.
 *
 * PLATFORM-FEE-CHANGE: changing the fee? See the runbook in
 * docs/features/costs-certificate-fee/00-OVERVIEW.md ("Changing the fee").
 */
export const FEE_PER_CERTIFICATE = 0.05;

/** Weekly sales open in February 2027, for 2026 and 2027 certificates alike. */
export const SALES_OPEN = '2027-02-01';

/** 30 Sep of the following year: the surrender deadline for a certificate year. */
export const surrenderDate = (year) => `${Number(year) + 1}-09-30`;

const QUARTER_END = { 1: '03-31', 2: '06-30', 3: '09-30', 4: '12-31' };

/** The last day of a quarter, as an ISO day. */
export const quarterEnd = (year, quarter) => `${year}-${QUARTER_END[quarter]}`;

/** 2026 has no quarterly holding check, only the surrender, priced per import quarter (D5). */
export const hasQuarterChecks = (year) => Number(year) >= 2027;

/** The dates a purchase for `year` may carry. */
export const purchaseWindow = (year) => ({ min: SALES_OPEN, max: surrenderDate(year) });

/**
 * The date a new purchase starts on: today, but never before sales open
 * (1 Feb 2027) nor after the year's surrender.
 */
export const defaultPurchaseDate = (year, today) => {
  const { min, max } = purchaseWindow(year);
  if (today < min) return min;
  if (today > max) return max;
  return today;
};
